'use client';
import './page.css';
import Image from 'next/image';
import { RegisterLink, LoginLink } from '@kinde-oss/kinde-auth-nextjs/components';
import { useSearchParams } from 'next/navigation';
import { useEffect, Suspense } from 'react';

function LoginContent() {
  const searchParams = useSearchParams();
  const redirectUrl = searchParams.get('post_login_redirect_url');

  useEffect(() => {
    if (redirectUrl) {
      document.cookie = `flowt_redirect_after_auth=${redirectUrl}; path=/; max-age=${60 * 60 * 24}; samesite=lax; secure=true`;
    }
  }, [redirectUrl]);

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'url("/login-hero-light.webp")',
        backgroundColor: '#F2F2F2',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <div style={{ maxWidth: '480px', width: '100%' }}>
        {/* Logo */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Image
            src="/flowt-logo-color.svg"
            alt="Flowt Logo"
            width={60}
            height={60}
            style={{ height: '60px', width: 'auto' }}
            priority
          />
        </div>

        {/* Content Container */}
        <div
          style={{
            marginTop: '16px',
            marginLeft: 0,
            marginRight: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            padding: '27px',
          }}
        >
          {/* Avatar with Lock Icon */}
          <div
            style={{
              margin: '8px',
              marginBottom: '16px',
              backgroundColor: '#B8A583',
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
            }}
          >
            {/* SVG lock icon in white */}
            <Image src="/flowt-lock-icon.svg" alt="Lock Icon" width={24} height={24} priority />
          </div>

          {/* Welcome Text */}
          <h1
            style={{
              fontSize: '24px',
              lineHeight: '32.016px',
              fontWeight: 600,
              marginBottom: '8.4px',
              boxSizing: 'border-box',
              color: 'rgba(0, 0, 0, 0.87)',
              display: 'block',
              WebkitFontSmoothing: 'antialiased',
              textAlign: 'center',
              textSizeAdjust: '100%',
              marginBlockEnd: '8.4px',
              marginBlockStart: '0px',
            }}
          >
            Welcome! Please sign in or register.
          </h1>

          {/* Sign In Button - Using Kinde LoginLink instead of Next.js Link */}
          <LoginLink
            className="sign-in-button"
            postLoginRedirectURL="/api/core/validate-or-create-user"
            style={{
              marginTop: '8px',
              color: '#B8A583',
              fontWeight: 600,
              fontSize: '16px',
              textTransform: 'capitalize',
              borderRadius: '8px',
              padding: '8px 16px',
              backgroundColor: 'transparent',
              textDecoration: 'none',
              border: 'none',
              display: 'inline-block',
              transition: 'background-color 0.3s, color 0.3s',
              cursor: 'pointer',
            }}
          >
            Sign In
          </LoginLink>

          {/* Sign Up Button - Using Kinde RegisterLink instead of Next.js Link */}
          <RegisterLink
            className="sign-up-button"
            postLoginRedirectURL="/api/core/validate-or-create-user"
            style={{
              marginTop: '8px',
              color: '#B8A583',
              fontWeight: 600,
              fontSize: '16px',
              textTransform: 'capitalize',
              borderRadius: '8px',
              padding: '8px 16px',
              border: '1px solid #B8A583',
              backgroundColor: 'transparent',
              textDecoration: 'none',
              display: 'inline-block',
              transition: 'background-color 0.3s, color 0.3s, border-color 0.3s',
              cursor: 'pointer',
            }}
          >
            Sign up for an account
          </RegisterLink>
        </div>
      </div>
    </main>
  );
}

export default function LoginPage() {
  return (
    <Suspense>
      <LoginContent />
    </Suspense>
  );
}
